import React, { useEffect, useState } from "react";
import { Button } from "../../../../../../shadcn/components/ui/button";
import { useSelector } from "react-redux";
import {
  getBidderByUuid,
  getDigioESignStatusForJoint,
  initiateDigioESignForJoint,
  updateBidderForEvent,
} from "services/bidder";
import SwitchToOfflineKycModal from "../../SwitchToOfflineKycModal";
import CustomLoadingModal from "../IndividualBidders/CustomLoadingModal";
import SwitchToOtherKYCModeNotification from "../SwitchToOtherKYCModeNotification";
import KycStatusNotice from "../KycStatusNotice";
interface JBSecondaryESignComponentProps {
  bidderUuid: any;
  bidder: any;
  stepsTitles: any;
  activeStep: any;
  setActiveStep: any;
  init: any;
}
export default function JBSecondaryESignComponent({
  bidderUuid,
  init,
  activeStep,
  setActiveStep,
  bidder,
}: JBSecondaryESignComponentProps) {
  console.log("bidder in secondary e sign: ", bidder);
  const onboardingData = useSelector((state: any) => {
    return state.bidderAuth.onboarding;
  });
  const [checkingStatus, setCheckingStatus] = useState<any>(false);
  const [isNavigated, setIsNavigated] = useState<any>(false);
  const [requestingStatus, setRequestingStatus] = useState<any>(false);
  const [isSignPending, setIsSignPending] = useState<any>(false);
  const [switchToOfflineModalOpen, setSwitchToOfflineModalOpen] =
    useState(false);
  const [switchingToOffline, setSwitchingToOffline] = useState(false);
  const [isOnlineModeIssue, setIsOnlineModeIssue] = useState(false);
  const [error, setError] = useState<any>("");
  const handleBannerSwitch = async () => {
    setSwitchToOfflineModalOpen(true);
  };
  useEffect(() => {
    const scriptId = "digio-sdk-script";

    // Check if script is already added
    if (!document.getElementById(scriptId)) {
      const script = document.createElement("script");
      script.id = scriptId;
      script.type = "text/javascript";
      script.src = "https://app.digio.in/sdk/v11/digio.js";
      script.async = true;

      document.body.appendChild(script);
      console.log("SCRIPT__INJECTED");

      // Cleanup function
      return () => {
        const existingScript = document.getElementById(scriptId);
        if (existingScript) {
          console.log("called");
          document.body.removeChild(existingScript);
        }
      };
    }
  }, [checkingStatus]);

  const handleRequestSigning = async () => {
    setRequestingStatus(true);
    try {
      setError("");
      const res: any = await initiateDigioESignForJoint({
        bidder_onboarding_uuid: onboardingData.uuid,
        eligible_bidders_uuid: bidderUuid,
      });
      setIsNavigated(true);
      console.log("res:------ ", res, res.data.id);
      var options = {
        environment: process?.env?.NEXT_PUBLIC_DIGIO_ENVIRONMENT,
        callback: async function (response: any) {
          if (response.hasOwnProperty("error_code")) {
            //check status of flow
            console.log("response---------->>>>", response);
            // return console.log("error occurred in process");
          }
          console.log("response---------->>>>", response);
          //check status of flow
          console.log("Signing;completed;successfully:");
          await init();
          setIsNavigated(false);
        },
        logo: process.env.NEXT_PUBLIC_IMAGIX_URL?.includes("staging")
          ? `${process.env.NEXT_PUBLIC_IMAGIX_URL}/24534319-e399-47f9-ad4c-f98d5d9bbbb3`
          : `${process.env.NEXT_PUBLIC_IMAGIX_URL}/fa4a3024-6d97-488b-88e0-a6f5d802b2ba`,
        is_redirection_approach: false,
        is_iframe: true,
        theme: {
          primaryColor: "#FF752C",
          secondaryColor: "#262626",
        },
      };
      // @ts-ignore
      var digio = new Digio(options);
      digio.init();
      digio.submit(
        res.data.id,
        onboardingData?.mobile,
        res.data?.access_token?.id,
      );
      setIsNavigated(true);
    } catch (error) {
      console.log("error:====>>> ", error);
      setError(
        "Oops! Something went wrong. Please try again in a few moments.",
      );
    }
    setRequestingStatus(false);
  };

  useEffect(() => {
    (async () => {
      try {
        if (!bidderUuid) return;
        await new Promise((resolve) => setTimeout(resolve, 1000));
        const data: any = await getBidderByUuid(bidderUuid);
        if (data?.esigned_data?.request_id) {
          setCheckingStatus(true);
          const payload = {
            eligible_bidders_uuid: bidderUuid,
            e_sign_request_id: data?.esigned_data?.request_id,
          };
          const res: any = await getDigioESignStatusForJoint(payload);
          if (res?.data?.agreement_status === "completed") {
            const data: any = await getBidderByUuid(bidderUuid);
            // update primary bidder status as well
            const primaryBidderUuid = data?.meta?.primary_bidder_uuid;
            const primaryBidderData: any = await getBidderByUuid(
              primaryBidderUuid,
            );
            const biddersConsent =
              primaryBidderData?.esigned_data?.consent_data || [];
            const consentData = [];
            for (const consent of biddersConsent) {
              if (consent.bidder_uuid === bidderUuid) {
                consentData.push({
                  ...consent,
                  consent_status: "approved",
                });
              } else {
                consentData.push(consent);
              }
            }
            await updateBidderForEvent({
              uuid: primaryBidderUuid,
              esigned_data: {
                ...primaryBidderData?.esigned_data,
                consent_data: consentData,
              },
            });
            await updateBidderForEvent({
              uuid: bidderUuid,
              meta: {
                ...data?.meta,
                submission_time: new Date().toISOString(),
                steps_status: {
                  ...data?.meta?.steps_status,
                  e_sign: "completed",
                },
              },
              esigned_data: {
                ...data?.esigned_data,
                e_signed_response: res?.data,
                consent_data: [
                  {
                    bidder_uuid: bidderUuid,
                    consent_status: "approved",
                    primary_bidder_uuid: primaryBidderUuid,
                  },
                ],
              },
              verification_step: "completed",
            });
            setActiveStep(activeStep + 1);
            await new Promise((resolve) => setTimeout(resolve, 1000));
            await init();
            setIsSignPending(false);
          } else {
            setIsSignPending(true);
            setIsOnlineModeIssue(true);
          }
          setCheckingStatus(false);
        }
      } catch (error) {
        console.log("error:--------123456789 ", error);
        setCheckingStatus(false);
      }
    })();
  }, [isNavigated, bidderUuid]);
  const handleSwitchToOffline = async () => {
    if (switchingToOffline) return;

    setSwitchingToOffline(true);
    setSwitchToOfflineModalOpen(false);
    try {
      const data: any = await getBidderByUuid(bidderUuid);
      await updateBidderForEvent({
        uuid: bidderUuid,
        meta: {
          ...data?.meta,
          bid_application_flow_mode: "offline",
        },
      });
      // Reload the page to show offline KYC flow
      window.location.reload();
    } catch (error) {
      console.log("error switching to offline KYC: ", error);
      setSwitchingToOffline(false);
    }
  };

  const isOfflineEnabled =
    process.env.NEXT_PUBLIC_ENABLE_OFFLINE_JOINT_INDIVIDUALS_KYC === "true";
  return (
    <div className="py-4 bg-white rounded-lg">
      <p className="text-lg font-semibold text-gray-700">
        Participation Consent
      </p>

      <p className="text-sm text-gray-600 mt-2">
        To participate in the e-auction, you must provide your consent by
        digitally signing the Joint Participation Agreement. This step confirms
        your agreement to join the bidding process.
      </p>

      <div className="my-4">
        {checkingStatus && (
          <KycStatusNotice
            variant="info"
            message="Checking your KYC status. Please wait..."
          />
        )}
        {isSignPending && !checkingStatus && (
          <KycStatusNotice
            variant="warning"
            message="Your E-sign process is incomplete. Please complete all required steps to proceed."
          />
        )}
        {isOfflineEnabled && isOnlineModeIssue && (
          <SwitchToOtherKYCModeNotification
            handleSwitch={handleBannerSwitch}
            switchingToModes={switchingToOffline}
            switchMode="Offline"
          />
        )}
      </div>

      <p className="text-sm text-gray-600 mt-2">
        The digital signing process is securely powered by{" "}
        <strong>Digio</strong>, ensuring your documents are legally valid and
        verifiable. Please ensure your Aadhaar-linked mobile number is active to
        receive the OTP required for signing.
      </p>
      <div className="mt-16 mb-10 md:mb-0">
        {error && <div className="text-sm text-brand-textRed">{error}</div>}
        <Button
          className="w-full max-w-xl h-10 text-lg"
          onClick={handleRequestSigning}
          disabled={checkingStatus || error}
        >
          Proceed
        </Button>
      </div>
      {requestingStatus && (
        <CustomLoadingModal
          loadingText="Preparing your e-sign process… please hold on for a moment."
          spinnerSize={48}
          overlayOpacity="50"
        />
      )}
      {isOfflineEnabled && switchToOfflineModalOpen && (
        <SwitchToOfflineKycModal
          open={switchToOfflineModalOpen}
          setOpen={setSwitchToOfflineModalOpen}
          handleConfirm={handleSwitchToOffline}
        />
      )}
    </div>
  );
}
